import React from 'react';
import {Button, Form} from "react-bootstrap";

const CreditInformationStep = ({activeStep, setActiveStep}) => {
    return (
        <>
            <div className="row justify-content-center">
                <div className="col-xl-10">
                    <div className="card custom-card">
                        <div className="card-body">
                            <h5 className="text-center">Credit Information</h5>

                            <div className="row">
                                <div className="col-lg-6">
                                    <Form.Group className="mb-3">
                                        <Form.Label>Credit Type:</Form.Label>
                                        <Form.Control type="text" placeholder="Visa" />
                                    </Form.Group>
                                </div>
                                <div className="col-lg-6">
                                    <Form.Group className="mb-3">
                                        <Form.Label>CCV#</Form.Label>
                                        <Form.Control type="text" placeholder="123456789" />
                                    </Form.Group>
                                </div>
                                <div className="col-lg-6">
                                    <Form.Group className="mb-3">
                                        <Form.Label>EXP:</Form.Label>
                                        <Form.Control type="date" placeholder="12/26" />
                                    </Form.Group>
                                </div>
                                <div className="col-lg-6">
                                    <Form.Group className="mb-3">
                                        <Form.Label>Security Code:</Form.Label>
                                        <Form.Control type="text" placeholder="123" />
                                    </Form.Group>
                                </div>
                                
                                <div className="col-lg-12 mt-5">
                                    <div className="row justify-content-between">
                                        <div className="col-lg-3 d-flex mb-3">
                                            <Button
                                                variant="primary"
                                                className="text-white mt-auto w-100"
                                                onClick={() => setActiveStep(pre => pre - 1)}
                                            >
                                                Previous
                                            </Button>
                                        </div>
                                        <div className="col-lg-3 d-flex mb-3">
                                            <Button
                                                variant="primary"
                                                className="text-white mt-auto w-100"
                                                onClick={() => setActiveStep(pre => pre + 1)}
                                            >
                                                Next
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CreditInformationStep;